export default __webpack_public_path__ + "static/media/tractor.bg.0bc316bf.svg";